import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function SideNavBar() {
  const location = useLocation();
  const isWorkspace = location.pathname.startsWith('/editor');

  return (
    <aside className="bg-surface-container dark:bg-surface-container-low h-full w-64 border-r border-outline-variant dark:border-white/10 flex flex-col py-panel-padding shrink-0 z-40 relative">
      <div className="px-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded bg-surface-container-highest flex items-center justify-center border border-outline-variant shrink-0 overflow-hidden" 
               style={!isWorkspace ? {
                 backgroundImage: "url('https://lh3.googleusercontent.com/aida-public/AB6AXuDfzTH5UJxxopHYLp5Mxowhp2cbWYIft88GsySAFNhV0FKxQEMPffTGOYRgjvN5ymNucEC2GnpA9ex6vpYP3BZhajZZR_5UcommIUakVWTOts4fXQUMIBI-7eWVfGn-0HWYnEGZnEU_k-l43LBqXWpQSewe2QSc1SE92_2hDW_BwSlkTdgNLEaXswhnlilEwJXMRr7UR4xy5-91aeCzrZ77FKh3crsM28u1NhKlrLq7TwuGKwirZcC_63g7d2vF4nYVUQYarcYkzOtJ')",
                 backgroundSize: 'cover',
                 backgroundPosition: 'center'
               } : {}}>
            {isWorkspace && <span className="material-symbols-outlined text-primary">web_stories</span>}
          </div>
          <div className="min-w-0">
            <h2 className="font-headline-h3 text-headline-h3 text-on-surface text-[16px] leading-tight truncate">Project Workspace</h2>
            <p className="font-label-sm text-label-sm text-on-surface-variant truncate mt-0.5">Current Session</p>
          </div>
        </div>
      </div>
      
      <nav className="flex-1 px-2 space-y-1">
        <Link 
          to="/editor" 
          className={`flex items-center gap-3 px-3 py-2.5 rounded-md font-label-md text-label-md transition-all ${
            isWorkspace 
              ? 'text-primary font-bold border-r-4 border-primary bg-primary/5' 
              : 'text-on-surface-variant hover:text-on-surface hover:bg-surface-variant'
          }`}
        >
          <span className="material-symbols-outlined" style={isWorkspace ? {fontVariationSettings: "'FILL' 1"} : {}}>edit_note</span>
          Editor
        </Link>
        <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-md text-on-surface-variant hover:text-on-surface hover:bg-surface-variant transition-all font-label-md text-label-md">
          <span className="material-symbols-outlined">palette</span>
          Style
        </a>
        <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-md text-on-surface-variant hover:text-on-surface hover:bg-surface-variant transition-all font-label-md text-label-md">
          <span className="material-symbols-outlined">folder_open</span>
          Library
        </a>
        <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-md text-on-surface-variant hover:text-on-surface hover:bg-surface-variant transition-all font-label-md text-label-md">
          <span className="material-symbols-outlined">movie</span>
          Export
        </a>
      </nav>
      
      <div className="px-2 mt-auto space-y-1 pt-4 border-t border-outline-variant">
        <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-md text-on-surface-variant hover:text-on-surface hover:bg-surface-variant transition-all font-label-md text-label-md">
          <span className="material-symbols-outlined">help_outline</span>
          Help
        </a>
        <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-md text-on-surface-variant hover:text-on-surface hover:bg-surface-variant transition-all font-label-md text-label-md">
          <span className="material-symbols-outlined">settings</span>
          Settings
        </a>
      </div>
    </aside>
  );
}
